import { v4 as uuidv4 } from "uuid";
import { MedOptionType } from "./types";
import { OptionTypeLocal } from "./types.local";

export class OptionConfigAdapter<T> implements OptionTypeLocal<T> {
  constructor({ value, disabled, required, label }: MedOptionType<T>) {
    this.id = uuidv4();
    this.value = value;
    this.label = label;
    this.disabled = disabled || this.disabled;
    this.required = required || this.required;
  }

  value!: T;
  id = "";
  label = "";
  disabled = false;
  required = false;
}
